/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import { ReactComponent as Icon } from 'Images/icon-toolbar-searchbar-loupe.svg';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  width: 264px;
  height: 38px;
  background: ${({ theme }) => theme.backgrounds.listItemOdd};
`;
Wrapper.displayName = 'Wrapper';

export const SearchIcon = styled(Icon)`
    height: 18px;
    width: 18px;
    path {
      fill: ${({ theme }) => theme.icons.actionBar.color};
    }
    ${({ disabled }) => disabled && 'opacity: 0.5; pointer-events: none'};
`;

SearchIcon.displayName = 'SearchIcon';
